import React from "react";

type Props<C extends {}> = C & {
  delay: number;
  children: (c: Omit<C, "delay" | "children">) => React.ReactNode;
};

export default class DelayProps<
  InputProps,
  P = Omit<InputProps, "delay" | "children">
> extends React.Component<Props<InputProps>, P> {
  timeout: NodeJS.Timeout | undefined;

  constructor(props: Props<InputProps>) {
    super(props);
    this.state = this.restProps(props);
  }

  componentDidUpdate(oldProps: Props<InputProps>) {
    if (oldProps === this.props) return;
    const rest = this.restProps();
    this.timeout = setTimeout(() => this.setState(rest), this.props.delay);
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  render() {
    return (this.props.children as any)(this.state);
  }

  restProps(props: Props<InputProps> = this.props): P {
    const { children, delay, ...rest } = props;
    return rest as any;
  }
}
